/**
 * DataScope - which data store the screens below are showing.
 *
 * Normally there is no scope and every component talks to /api as always.
 * The GLOBAL KSA tab (src/components/ksa/KsaDataProvider.jsx) wraps the REAL
 * Opportunities and Projects views in KSA_SCOPE plus its own AppContext value,
 * so they show and edit the separate KSA records instead. The components that
 * call fetch() directly take their prefix from useApiBase() - tasks, comments
 * and the Doc Hub (panel, index, file preview), which KSA has its own copy of.
 * The GlobalOps-only pieces (finance, the canonical name
 * lists) check useDataScope() and stay out of it.
 *
 * This file is the only place in src/ that names /api/ksa
 * (server/test_ksa.js holds it to that).
 */
import { createContext, useContext } from 'react';

export const KSA_SCOPE = Object.freeze({ key: 'ksa', apiBase: '/api/ksa', label: 'GLOBAL KSA' });

export const DataScopeContext = createContext(null);
export const useDataScope = () => useContext(DataScopeContext);
/** '/api' normally, '/api/ksa' inside the KSA tab. */
export const useApiBase = () => useContext(DataScopeContext)?.apiBase || '/api';
